import CachedIcon from '@mui/icons-material/Cached';
import { Grid, Skeleton, Typography, useTheme } from '@mui/material';
import useFormatNumber from 'hooks/useFormatNumber';
import { FormattedMessage } from 'react-intl';
import { TGetBalance } from 'types/wallet';
import BackgroundCard from 'ui-component/cards/BackgroundCard';
import NumberSupSymbol from 'views/pages/merchant/wallet/wallet-detail/components/deposit-withdraw/components/NumberSupSymbol';

const TotalBalanceSection = ({ onRefetch, data, isLoading }: { onRefetch: () => void; data: TGetBalance; isLoading: boolean }) => {
    const theme = useTheme();
    const { fCrypto, fFiat } = useFormatNumber();

    return (
        <BackgroundCard>
            <Grid container flexDirection="row" gap={1} alignItems="center">
                <Grid item>
                    <Typography variant="h5">
                        <FormattedMessage id="total-balance" />:
                    </Typography>
                </Grid>
                <Grid item>
                    <CachedIcon fontSize="small" color="primary" sx={{ cursor: 'pointer' }} onClick={onRefetch} />
                </Grid>
            </Grid>
            <Grid container flexDirection="row" gap={1} alignItems="center">
                {isLoading ? (
                    <Skeleton variant="text" height={23.5} width="70%" animation="wave" />
                ) : (
                    <>
                        <NumberSupSymbol
                            variant="h2"
                            content={`${fCrypto(data?.balanceBtc || 0)} BTC`}
                            symbol=""
                            colorText={theme.palette.text.dark}
                            colorSupText={theme.palette.text.dark}
                            fsMainText="1.2rem"
                            fw={600}
                            display
                        />
                        <NumberSupSymbol
                            variant="h4"
                            content={`≈ $${fFiat(data?.balanceUsd || 0)}`}
                            symbol=""
                            colorText={theme.palette.text.dark}
                            colorSupText={theme.palette.text.dark}
                            fs="0.8rem"
                        />
                    </>
                )}
            </Grid>
        </BackgroundCard>
    );
};

export default TotalBalanceSection;
